/** The enrollment the student is in now, if any (list is newest first). */
export const currentEnrollment = (enrollments: any[]): any | null =>
  enrollments.find((e: any) => e.enrollmentStatus === 'enrolled') ?? null;

/** "Class 9 · A" — the class, and the section when there is one. */
export const placementName = (e: any): string | undefined => {
  const cls = e?.classId?.name;
  if (!cls) return undefined;
  const section = e?.sectionInstanceId?.name;
  return section ? `${cls} · ${section}` : cls;
};
